import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  IQuizBlockDTO,
  QuizBlockDTO,
} from '@app/infrastructure/models/quiz-block';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-quiz-bool',
  templateUrl: './quiz-bool.component.html',
  styleUrls: ['./quiz-bool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizBoolComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup = new UntypedFormGroup({});
  @Input() quiz: IQuizBlockDTO = new QuizBlockDTO();
  @Output() answerUpdatedEmitter: EventEmitter<IQuizBlockDTO> =
    new EventEmitter();

  private ctrlName: string = 'boolChoice';
  private subscriptions: Subscription[] = [];
  constructor() {}

  ngOnInit(): void {
    if (this.quiz.trueOrFalse !== null)
      this.form.addControl(
        this.ctrlName,
        new UntypedFormControl(this.quiz.trueOrFalse),
      );
    else this.form.addControl(this.ctrlName, new UntypedFormControl(''));

    const sub = this.form.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value: { boolChoice: boolean | string }) => {
        this.quiz.trueOrFalse = value.boolChoice == 'true';
        this.answerUpdatedEmitter.emit(this.quiz);
      });
    this.subscriptions.push(sub);
  }
  ngOnDestroy(): void {
    this.form.removeControl(this.ctrlName);
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
  public get stepForm() {
    return this.form?.get('name')?.value;
  }

  public isChecked(value: boolean) {
    return this.quiz.trueOrFalse === value;
  }
}
